import { all } from 'redux-saga/effects';
import operatorUserWatcher from './OperatorUserSaga';

function* operatorUserSaga() {
  yield all([
    operatorUserWatcher(),
  ]);
}

export default operatorUserSaga;
